import instance from '@/api/axios'

export const backgroundsApi = {
  async getAll() {
    return await instance.get('/backgrounds')
  }
}
